import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    let storedUser = null;
    const userString = localStorage.getItem('user');

    if (userString) {
      try {
        storedUser = JSON.parse(userString);
      } catch (e) {
        console.error('Error parsing user from localStorage:', e);
        localStorage.removeItem('user');
      }
    }

    this.currentUserSubject = new BehaviorSubject<any>(storedUser);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  getUserRole(): string {
    const userValue = this.currentUserValue;
    if (!userValue) return '';

    return userValue.role || '';
  }

  public hasCreateTablePermission(): boolean {
    if (this.isOwner()) {
      return true;
    }

    const permissionsString = localStorage.getItem('user_permissions');
    if (permissionsString) {
      try {
        const permissions = JSON.parse(permissionsString);if (permissions && permissions.tablePermissions &&
          permissions.tablePermissions.create_table === true) {
          return true;
        }
      } catch (e) {
        console.error('Error parsing user permissions:', e);
      }
    }

    return false;
  }

  private getUserPermissions(): any {
    const permissionsString = localStorage.getItem('user_permissions');
    if (permissionsString) {
      try {
        return JSON.parse(permissionsString);
      } catch (e) {
        console.error('Error parsing user permissions:', e);
      }
    }
    return null;
  }

  getUserId(): number {
    const userValue = this.currentUserValue;
    if (!userValue) return 0;

    return userValue.id || 0;
  }

  isOwner(): boolean {
    const userRole = this.getUserRole();
    return userRole?.toLowerCase() === 'owner';
  }

  canManageUser(userId: number): boolean {
    if (this.isOwner()) {
      return true;
    }

    const permissions = this.authService.getPermissions();

    return permissions.some(p =>
      p.permission_name === 'manage_user' &&
      p.table_id === userId
    );
  }

  getEmployees(params: any): Observable<any> {
    const subsidiaryId = this.authService.getCurrentSubsidiaryId();

    if (subsidiaryId) {
      params.subsidiary_id = subsidiaryId;
    }

    return this.http.post<any>('/api/employees', params);
  }

  addEmployee(employee: any): Observable<any> {
    const subsidiaryId = this.authService.getCurrentSubsidiaryId();

    if (subsidiaryId) {
      employee.subsidiary_id = subsidiaryId;
    }

    return this.http.post<any>('/api/employees/add', employee);
  }

  updateEmployee(id: number, employee: any): Observable<any> {
    const subsidiaryId = this.authService.getCurrentSubsidiaryId();

    if (subsidiaryId) {
      employee.subsidiary_id = subsidiaryId;
    }

    return this.http.put<any>(`/api/employees/${id}`, employee);
  }

  deleteEmployee(id: number): Observable<any> {
    const subsidiaryId = this.authService.getCurrentSubsidiaryId();
    let url = `/api/employees/${id}`;

    if (subsidiaryId) {
      url += `?subsidiary_id=${subsidiaryId}`;
    }

    return this.http.delete<any>(url);
  }

  assignRoleToEmployee(
    userId: number,
    roleId: number,
    subsidiaryId: number,
    isDefault: boolean = false
  ): Observable<any> {
    return this.http.post<any>('/api/user-roles', {
      user_id: userId,
      role_id: roleId,
      subsidiary_id: subsidiaryId,
      is_default: isDefault
    });
  }

  loadManagers(){
    return this.http.get<any>('/api/employees/managers')
  }

  removeManager(employee_id: number){
    return this.http.delete<any>(`/api/employees/${employee_id}/manager`)
  }

  assigningManager(employee_id: any, data: any){
    return this.http.post<any>(`/api/employees/${employee_id}/manager`, data)
  }
}